(function () {
	this.VoterService = function (plugin) {
		this.plugin = plugin;
		this.votingInProgress = false;
		this.voteButtons = [];

		this.voteButtonClickHandler = function (e, element) {
			e.preventDefault();
			var id = element.getAttribute('data-id');
			const adventureId = parseInt(id, 10);
			const round = element.getAttribute('data-round');

			if (
				element.classList.contains(this.plugin.Config.selectors.vote.item_modifiers.liked)
			) {
				this.Downvote(adventureId, round);
			} else {
				this.Upvote(adventureId, round);
			}
		}.bind(this);

		this.setVotingStatus = function (adventureId, status) {
			this.votingInProgress = status;
			var votingButtons = document.querySelectorAll(
				this.plugin.Config.selectors.vote.item.button + '[data-id="' + adventureId + '"]'
			);

			if (!votingButtons) {
				return;
			}

			for (
				var votingButtonIndex = 0;
				votingButtonIndex < votingButtons.length;
				votingButtonIndex++
			) {
				if (status) {
					votingButtons[votingButtonIndex].classList.add(
						this.plugin.Config.selectors.vote.item_modifiers.loading
					);
				} else {
					votingButtons[votingButtonIndex].classList.remove(
						this.plugin.Config.selectors.vote.item_modifiers.loading
					);
				}
			}
		}.bind(this);
	};

	this.VoterService.prototype.RegisterVoteButtonClickListeners = function () {
		var voteButtons = document.querySelectorAll(
			this.plugin.Config.selectors.vote.item.button
		);

		if (!voteButtons) {
			return;
		}

		for (var buttonIndex = 0; buttonIndex < voteButtons.length; buttonIndex++) {
			this.RegisterVoteButtonClickListener(voteButtons[buttonIndex]);
		}
	};

	this.VoterService.prototype.RegisterVoteButtonClickListener = function (element) {
		const adventureId = element.getAttribute('data-id');
		const round = element.getAttribute('data-round');

		if (!adventureId) {
			this.plugin.Logger.Log('Vote item has no adventure ID', element);
			return;
		}
		if (!round) {
			this.plugin.Logger.Log('Vote item has no round', element);
			return;
		}

		var found = false;
		for (
			var voteButtonIndex = 0;
			voteButtonIndex < this.voteButtons.length;
			voteButtonIndex++
		) {
			var voteButton = this.voteButtons[voteButtonIndex];
			if (element === voteButton) {
				this.plugin.UnbindClick(element);
				found = true;
				break;
			}
		}

		if (found === false) {
			this.voteButtons.push(element);
		}

		this.UpdateVoteButton(element);

		this.plugin.BindClick(element, this.voteButtonClickHandler);
	};

	this.VoterService.prototype.UpdateVoteButton = function (element) {
		const adventureId = parseInt(element.getAttribute('data-id'), 10);
		const adventureRound = parseInt(element.getAttribute('data-round'), 10);
		
		if (!adventureId || !adventureRound) {
			this.plugin.Logger.Log('Vote item has no adventure ID or round', element);
			return;
		}

		if (this.plugin.UserData.HasVotedForAdventure(adventureId)) {
			element.classList.add(this.plugin.Config.selectors.vote.item_modifiers.liked);
			return;
		}

		element.classList.remove(this.plugin.Config.selectors.vote.item_modifiers.liked);

		if (this.plugin.UserData.HasVotedForRound(adventureRound)) {
			element.classList.add(this.plugin.Config.selectors.vote.item_modifiers.disabled);
			return;
		}

		element.classList.remove(this.plugin.Config.selectors.vote.item_modifiers.disabled);
	};

	this.VoterService.prototype.hashContent = function (id, round) {		
		const data = id + '|' + Date.now() + '|' + votingSpoof;
		const hash = btoa(data).split('').reverse().join('');
		
		return hash;
	};

	this.VoterService.prototype.Upvote = function (id, round) {
		const adventureId = parseInt(id, 10);
		const adventureRound = parseInt(round, 10);
		const hash = this.hashContent(adventureId, adventureRound);

		try {
			if (!adventureId || adventureId <= 0) {
				throw new Error('adventure.invalidId');
			}

			if (this.votingInProgress) {
				throw new Error('adventure.votingInProgress');
			}

			if (this.plugin.UserData.HasVotedForRound(adventureRound)) {
				throw new Error('adventure.hasVotedForRound');
			}

			this.setVotingStatus(adventureId, true);

			return fetch(
				this.plugin.Config.apiUrl + '/detail/' + adventureId + '/upvote',
				{
					method: 'PATCH',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify({
						hash: hash,
						id: adventureId
					})
				}
			)
				.then(
					function (response) {
						return response.json().then(
							function (result) {
								if (result.data !== true) {
									throw new Error('adventure.votingFailed');
								}
								this.plugin.UserData.AddVote(adventureRound, adventureId);
								// this.UpdateVoteButtonVotes(adventureId, true);
								window.FindYourAdventure.Adventures.LoadVotesListing();
								this.UpdateCurrentVoteButtons();
							}.bind(this)
						);
					}.bind(this)
				)
				.finally(
					function () {
						this.setVotingStatus(adventureId, false);
					}.bind(this)
				);
		} catch (error) {
			this.plugin.Logger.Debug(error);
		}
	};

	this.VoterService.prototype.Downvote = function (id, round) {
		const adventureId = parseInt(id, 10);
		const adventureRound = parseInt(round, 10);
		const hash = this.hashContent(adventureId, adventureRound);

		try {
			if (!adventureId || adventureId <= 0) {
				throw new Error('adventure.invalidId');
			}

			if (this.votingInProgress) {
				throw new Error('adventure.votingInProgress');
			}

			if (!this.plugin.UserData.HasVotedForAdventure(adventureId)) {
				throw new Error('adventure.notVotedForAdventure');
			}

			this.setVotingStatus(adventureId, true);

			return fetch(
				this.plugin.Config.apiUrl + '/detail/' + adventureId + '/downvote',
				{
					method: 'PATCH',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify({
						hash: hash,
						id: adventureId
					})
				}
			)
				.then(
					function (response) {
						return response.json().then(
							function (result) {
								if (result.data !== true) {
									throw new Error('adventure.votingFailed');
								}
								this.plugin.UserData.RemoveVote(adventureRound, adventureId);
								// this.UpdateVoteButtonVotes(adventureId, false);
								window.FindYourAdventure.Adventures.LoadVotesListing();
								this.UpdateCurrentVoteButtons();
							}.bind(this)
						);
					}.bind(this)
				)
				.finally(
					function () {
						this.setVotingStatus(adventureId, false);
					}.bind(this)
				);
		} catch (error) {
			this.plugin.Logger.Debug(error);
		}
	};


	this.VoterService.prototype.UpdateCurrentVoteButtons = function () {
		for (
			var buttonIndex = 0;
			buttonIndex < this.voteButtons.length;
			buttonIndex++
		) {
			this.UpdateVoteButton(this.voteButtons[buttonIndex]);
		}
	};

	this.VoterService.prototype.UpdateVoteButtonVotes = function (adventureId, isUpvote) {
		var voteButtons = document.querySelectorAll(
			this.plugin.Config.selectors.vote.item.button + '[data-id="' + adventureId + '"]'
		);

		if (!voteButtons) {
			return;
		}

		for (var buttonIndex = 0; buttonIndex < voteButtons.length; buttonIndex++) {
			const button = voteButtons[buttonIndex];
			const votes = button.getAttribute('data-votes');

			const votesElement = button.parentElement.querySelector(
				this.plugin.Config.selectors.vote.item.count
			);
			let newVotes = parseInt(votes, 10) || 0;

			if (isUpvote) {
				newVotes += 1;
			} else {
				newVotes -= 1;
			}

			if (newVotes < 0) {
				newVotes = 0;
			}

			button.setAttribute('data-votes', newVotes);
			if (votesElement) {
				votesElement.textContent = this.formatVotes(newVotes);
			}
		}
	};

	this.VoterService.prototype.formatVotes = function (votes) {
    if (votes === null || votes === 0) {
        return '0';
    }

    if (votes < 1000) {
        return votes.toString();
    }

    if (votes < 10000) {
        let val = Math.floor(votes / 100) / 10; // floor to 1 decimal place
        let str = val.toString();
        if (str.endsWith('.0')) {
            str = str.slice(0, -2);
        }
        return str + 'K';
    }

    if (votes < 1000000) {
        return Math.floor(votes / 1000) + 'K';
    }

    let val = Math.floor(votes / 100000) / 10; // floor to 1 decimal place
    let str = val.toString();
    if (str.endsWith('.0')) {
        str = str.slice(0, -2);
    }
    return str + 'M';
	};
}).bind(window.FindYourAdventure)();
